<template>
  <!-- grid of registered paying users, with filters, stock buttons (CRUD), pagination and possibility to enable and disable the user. -->

  <div>
    <preload v-if="preload"></preload>
    <nav-bar></nav-bar>
    <div style="min-height: 100vh">
      <div class="container contact">
        <div class="row" style="padding-top: 30px">
          <!-- DESKTOP SCREEN -->

          <div class="col-md-12 class-desktop">
            <p class="page-user">Meus sacados</p>

            <div class="form-group">
              <div class="row" style="width: 100%">
                <div class="col-md-12">
                  <div style="margin-top: -30px; margin-left: -23px">
                    <div>
                      <button
                        style="background-color: transparent"
                        data-target="#filterinputsdesktop"
                        data-toggle="collapse"
                        id="collapseMyUsers"
                        class="btn colaccordion-toggle"
                      >
                        Filtro
                        <em class="fa fa-chevron-down icons icon-chevron"></em>
                      </button>
                    </div>

                    <div class="hiddenRow column">
                      <div
                        class="accordian-body collapse"
                        style="margin-left: 10px"
                        id="filterinputsdesktop"
                      >
                        <div class="form-group">
                          <form
                            @submit.prevent="
                              setFilter(filterSearch, filterText, true)
                            "
                            class="has-search"
                          >
                            <div style="display: flex">
                              <select
                                v-model="filterSearch"
                                class="selectpicker"
                                v-on:change="clearFilterText"
                              >
                                <option value="selecione">Selecione</option>
                                <option value="sac_inscricao">
                                  Inscrição pagador
                                </option>
                                <option value="sac_razao_social_nome">
                                  Pagador
                                </option>
                                <option value="ced_inscricao">
                                  Inscrição beneficiário
                                </option>
                                <option value="ced_razao_social_nome">
                                  Beneficiário
                                </option>
                              </select>

                              <input
                                type="text"
                                class="form-control"
                                id="MyUsersSearchComponent"
                                placeholder="Digite o que deseja filtrar"
                                v-model="filterText"
                                :disabled="filterSearch == 'selecione'"
                                style="width: 35%"
                                min="3"
                              />
                            </div>
                            <div
                              style="display: flex; justify-content: flex-end"
                            >
                              <button
                                class="btn btn-lg access-filter"
                                type="submit"
                                id="myUsersSearchComponent"
                                v-on:click="
                                  setFilter(filterSearch, filterText, true)
                                "
                              >
                                Pesquisar
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: -35px">
              <!-- table of registered users desktop screen -->
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <table class="table">
                  <thead style="line-height: 5px">
                    <tr
                      style="
                        background-color: #ebe7e7 !important;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      <th style="padding-top: 25px"></th>

                      <th v-if="payers[0] && payers[0].atualiza_sacado">
                        Editar
                      </th>

                      <th @click="sort('sac_inscricao')">
                        Inscrição pagador<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'sac_inscricao;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'sac_inscricao;desc'"
                        ></em>
                      </th>
                      <th @click="sort('sac_razao_social_nome')">
                        Pagador<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'sac_razao_social_nome;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="
                            filters.order_by == 'sac_razao_social_nome;desc'
                          "
                        ></em>
                      </th>

                      <th @click="sort('ced_inscricao')">
                        Inscrição beneficiário<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'ced_inscricao;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'ced_inscricao;desc'"
                        ></em>
                      </th>
                      <th @click="sort('ced_razao_social_nome')">
                        Beneficiário<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'ced_razao_social_nome;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="
                            filters.order_by == 'ced_razao_social_nome;desc'
                          "
                        ></em>
                      </th>
                      <th @click="sort('sac_email')">
                        E-mail<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'sac_email;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'sac_email;desc'"
                        ></em>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="payer in payers" :key="'table_' + payer.sac_id">
                      <th scope="row" style="padding: 0.5rem"></th>

                      <td class="align-middle" v-if="payer.atualiza_sacado">
                        <button
                          id="editButtonMyUsers"
                          style="
                            background-color: transparent;
                            text-align: center;
                          "
                          class="btn-lg dropdown-item font-style"
                          @click="openEditMyUsersModal(payer.sac_id)"
                        >
                          <em class="fa fa-edit fa-icon"></em>
                        </button>
                      </td>
                      <td class="align-middle">
                        {{ payer.sac_inscricao | formatCPFCNPJ }}
                      </td>
                      <td class="align-middle">
                        {{ payer.sac_razao_social_nome }}
                      </td>
                      <td class="align-middle">
                        {{ payer.ced_inscricao | formatCPFCNPJ }}
                      </td>
                      <td class="align-middle">
                        {{ payer.ced_razao_social_nome }}
                      </td>
                      <td class="align-middle">{{ payer.sac_email }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="buttons-flutter-desktop">
                <pagination
                  v-if="pagination.last_page > 1"
                  :pagination="pagination"
                  :offset="5"
                  @paginate="getMyPayers()"
                ></pagination>

                <p class="total-page">
                  Total de sacados:
                  <span style="margin-left: 2px">
                    {{ this.pagination.total }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- END OF DESKTOP SCREEN -->

        <!-- MOBILE SCREEN -->
        <!-- form filters of registered users mobile screen -->
        <div class="row justify-content-center class-mobile">
          <div class="col-md-8"></div>
          <div class="col-md-8">
            <p class="page-user">Meus sacados</p>
            <div style="margin-bottom: 15px; margin-left: -23px">
              <div style="margin-left: 10px">
                <button
                  style="background-color: transparent"
                  data-toggle="collapse"
                  data-target="#filterinputs"
                  id="myUsersCollapseMobile"
                  class="btn colaccordion-toggle"
                >
                  Filtro <em class="fa fa-chevron-down icons icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div
                  class="accordian-body collapse"
                  style="margin-left: 30px"
                  id="filterinputs"
                >
                  <div class="form-group">
                    <form
                      @submit.prevent="
                        setFilter(filterSearch, filterText, true)
                      "
                      class="has-search"
                    >
                      <div style="display: flex">
                        <select
                          v-model="filterSearch"
                          class="selectpicker"
                          v-on:change="clearFilterText"
                        >
                          <option value="selecione">Selecione</option>
                          <option value="sac_inscricao">
                            Inscrição pagador
                          </option>
                          <option value="sac_razao_social_nome">Pagador</option>
                          <option value="ced_inscricao">
                            Inscrição beneficiário
                          </option>
                          <option value="ced_razao_social_nome">
                            Beneficiário
                          </option>
                        </select>
                        <input
                          type="text"
                          id="myUsersMobileSearch"
                          class="form-control"
                          placeholder="Digite o que deseja filtrar"
                          v-model="filterText"
                          :disabled="filterSearch == 'selecione'"
                          style="width: 60%; font-size: 13px; margin-left: 10px"
                          min="3"
                        />
                      </div>
                      <div style="display: flex; justify-content: center">
                        <button
                          id="searchButtonMobile"
                          class="btn btn-lg access"
                          type="submit"
                          style="width: 30%"
                          v-on:click="setFilter(filterSearch, filterText, true)"
                        >
                          Pesquisar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <!-- table list of registered users mobile screen -->
            <div
              v-for="payer in payers"
              :key="'table_' + payer.sac_id"
              class="principal-div"
            >
              <div class="col col-divs">
                <div style="width: 90%">
                  <label>Pagador</label><br />{{ payer.sac_inscricao }} -
                  {{ payer.sac_razao_social_nome }}
                </div>

                <button
                  style="width: 10%; background-color: #fff"
                  class="btn accordion-toggle"
                  data-toggle="collapse"
                  id="collapseButtonMyUsersMobile"
                  :data-target="'#' + payer.sac_id"
                >
                  <em class="fa fa-chevron-down icons icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div class="accordian-body collapse" :id="payer.sac_id">
                  <div class="col col-divs">
                    <div style="width: 90%">
                      <label>Beneficiário</label><br />{{ payer.ced_inscricao }}
                      -
                      {{ payer.ced_razao_social_nome }}
                    </div>
                    <button
                      v-if="payer.atualiza_sacado"
                      id="editButtonMyUsersMobile"
                      class="btn btn-lg dropdown-item font-style"
                      style="width: 10%; background-color: transparent"
                      type="button"
                      @click="openEditMyUsersModal(payer.sac_id)"
                    >
                      <em class="fa fa-edit fa-icon"></em>
                    </button>
                  </div>
                  <div class="col col-divs">
                    <div style="width: 90%">
                      <label>E-mail</label><br /><span
                        style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: block;
                        "
                        >{{ payer.sac_email }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="buttons-flutter">
              <p class="total-page">
                Total de sacados: {{ this.pagination.total }}
              </p>
            </div>
            <!-- pagination of registered users mobile screen -->

            <pagination
              v-if="pagination.last_page > 1"
              :pagination="pagination"
              :offset="5"
              @paginate="getMyPayers()"
            ></pagination>
            <!-- END OF MOBILE SCREEN -->
          </div>
        </div>
      </div>
      <edit-my-users-modal
        v-if="showEditUsersModal"
        :key="renderEditMyUsersModal"
        v-bind="showModalProps"
        @updateTable="getMyPayers"
      ></edit-my-users-modal>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>
<script>
import Vue from "vue";
import NavBar from "../../../common/components/NavBar";
import axios from "axios";
import Pagination from "../../../common/components/Pagination";
import * as cpf from "@fnando/cpf";
import FooterNav from "../../../common/components/FooterNav";
import EditMyUsersModal from "./EditMyUsersModal";
import Preload from "../../../common/components/Preload.vue";

export default {
  components: {
    Preload,
    Pagination,
    NavBar,
    FooterNav,
    EditMyUsersModal,
  },
  name: "MyUsers",

  data() {
    return {
      payers: [],
      pagination: {
        current_page: 1,
      },
      filters: {
        order_by: "sac_razao_social_nome;asc",
      },
      currentSort: "",
      currentSortDir: "asc",
      filterText: "",
      preload: false,
      show: true,
      showEditUsersModal: false,
      userId: false,
      renderEditMyUsersModal: Math.random(),
      filterSearch: "",
      sacId: "",
    };
  },

  methods: {
    getMyPayers(firstPage = false) {
      this.preload = true;
      if (firstPage) {
        this.pagination = {
          current_page: 1,
          total: 0,
          per_page: 15,
          last_page: 1,
          from: 0,
          to: 0,
        };
      }
      axios
        .get(`${process.env.API_PBM}/payers/myPayers?page=${this.pagination.current_page}`, {
          params: this.filters,
        })
        .then((response) => {
          if (response.data.data.payers) {
            this.payers = response.data.data.payers;
            this.pagination = response.data.data.pagination;
            this.preload = false;
            return;
          }
          this.pagination.total = 0;
          this.payers = [];
          this.preload = false;
        })
        .catch((error) => {
          Vue.$toast.error("Ops! Não foi possível buscar os dados.", {
            position: "top-right",
            duration: 5000,
          });
          this.preload = false;
        });
    },
    setFilter(filter, value, reset = false) {
      if (reset) {
        this.filters = {};
      }
      this.filters[filter] = value;
      this.getMyPayers(true);
      this.buttonChecked = value;
    },

    removeFilter(filter) {
      delete this.filters[filter];
      this.getMyPayers(true);
      this.buttonChecked = "todos";
    },

    clearFilterText() {
      this.filterText = "";
      if (this.filterSearch === "selecione") {
        this.filters = {};
        this.getMyPayers(true);
      }
    },

    sort(field) {
      if (field === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = field;
      this.filters["order_by"] = `${field};${this.currentSortDir}`;
      this.getMyPayers();
    },

    openEditMyUsersModal(sac_id) {
      this.sacId = sac_id;
      this.showEditUsersModal = true;
      this.renderEditMyUsersModal += 1;
    },
  },
  mounted() {
    this.$store.state.navBarActive = "";
    this.getMyPayers();

    this.filterSearch = "selecione";
  },
  computed: {
    showModalProps() {
      return { sacId: this.sacId };
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-user {
  font-size: 18px;
  margin-bottom: 15px;
  display: block;
  margin-top: -5px;
}

.dropdown {
  position: inherit;
}

.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
table thead {
  background-color: #cacaca;
  color: rgb(100, 95, 95);
  z-index: 2;
  position: inherit;
}
td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table {
  position: relative;
}
.my-custom-scrollbar {
  position: relative;
  height: 350px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}

.table thead th {
  position: sticky;
  top: 0;
  background-color: rgb(235, 231, 231) !important;
}
table tr {
  white-space: nowrap;
}
tbody {
  font-size: 12px;
  color: rgb(100, 95, 95);
}

.total-page {
  color: rgb(100, 95, 95);
  font-size: 14px;
}
.has-search .form-control-feedback {
  color: gray;
  margin-top: 4px;
  margin-left: 10px;
  width: 100%;
}

.fa-sort-down {
  margin-left: 5px;
  cursor: pointer;
  color: #424242;
}
.fa-sort-up {
  margin-left: 5px;
  cursor: pointer;
  position: absolute;
  color: #424242;
}
.icons {
  font-size: 20px;
  cursor: pointer;
}

.icons-btn {
  background-color: #fff;
  cursor: pointer;
  border: none;
}

.font-style {
  font-size: 20px;
  color: rgb(100, 95, 95);
  cursor: pointer;
}

.fa-icon {
  color: #424242;
}

.fa-style {
  font-size: 17px;
  padding-left: 30px;
  color: rgb(100, 95, 95);
}

.items-style {
  box-shadow: rgb(100, 95, 95) !important;
}

.btn {
  line-height: 1rem;
}

.btn-filter {
  color: #424242;
  background-color: #fff;
  border: 1px solid #ebe7e7;
  width: 120px;
}
.btn-filter:hover {
  color: #fff !important;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}

.contact {
  padding: 4%;
}

.contact-info h2 {
  margin-bottom: 10%;
}
.col-md-12 {
  background: #fff;
  padding: 3%;
  border-radius: 0.2rem;
}
.contact-form label {
  font-weight: 600;
}

label {
  font-size: 17px;
  color: rgb(100, 95, 95);
  margin-bottom: 1px;
}
.form-group input,
textarea {
  background-color: #fff;
  margin-bottom: 10px;
  margin-top: 3px;
  line-height: 1rem;
  font-size: 15px;
  margin-left: 10px;
  width: 42%;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.btn:focus {
  box-shadow: none !important;
}

.access {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
}

.access-filter {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 15px;
  height: 32px;
  width: 15%;
  margin-top: -42px;
}

.selectpicker {
  height: 30px;
  font-size: 13px;
  color: rgb(100, 95, 95);
  width: 15%;
  margin-top: 5px;
}

.buttons-flutter-desktop {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.contact-form button:focus {
  box-shadow: none;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 49px;
  height: 26px;
  float: left;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 13px;
  left: 16px;
  right: 9px;
  bottom: 2px;
  border-radius: 12px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 13px;
  left: -8px;
  bottom: -1px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 17px;
  box-shadow: 1px 1px 1px;
}

input.success:checked + .slider {
  background-color: #58970f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

@media only screen and (max-width: 900px) {
  .page-user {
    font-size: 20px;
    display: flex;
    justify-content: center;
  }

  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }

  .col-md-8 {
    background: #ebe7e7;
    padding: 3%;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .buttons-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }

  .access {
    color: #fff;
    border-radius: 6px;
    width: 45%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .btn-filter {
    color: #424242;
    background-color: #fff;
    border: 1px solid #ebe7e7;
    font-size: 14px;
    line-height: 1;
    width: 35%;
    cursor: pointer;
  }
  .btn-filter:hover {
    color: #fff !important;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }
  .btn-checked {
    color: #fff;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }

  .hiddenRow {
    padding: 0 !important;
  }

  label {
    display: inline-block;
    font-size: 13px;
    color: #424242;
  }

  .icons {
    font-size: 20px;
    cursor: pointer;
  }

  .col-divs {
    display: inline-flex;
    margin: 0 auto;
    font-size: 11px;
  }

  .principal-div {
    margin-top: 20px;
    background-color: #fff;
    border-radius: 6px;
    padding: 5px;
    color: rgb(100, 95, 95);
  }
  .access-filter {
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    height: 33px;
    width: 20%;
  }
  .access-mobile {
    color: #fff;
    border-radius: 6px;
    width: 100%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .form-group input,
  textarea {
    background-color: #fff;
    margin-bottom: 10px;
    margin-top: 3px;
    line-height: 1rem;
    font-size: 15px;
    margin-left: 0px;
    width: 100%;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 49px;
    height: 26px;
    float: left;
  }

  /* Hide default HTML checkbox */
  .switch input {
    display: none;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 6px;
    left: 16px;
    right: 9px;
    bottom: 10px;
    border-radius: 12px;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 13px;
    left: -8px;
    bottom: -1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 17px;
    box-shadow: 1px 1px 1px;
  }

  input.success:checked + .slider {
    background-color: #58970f;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .selectpicker {
    width: 35%;
  }
}

.class-mobile {
  display: none;
}

.buttons-flutter {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.access {
  color: #fff;
  border-radius: 6px;
  width: 100%;
  height: 70%;
  font-size: 11px;
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
  text-align: center;
}

.btn-filter {
  color: #424242;
  background-color: #fff;
  border: 1px solid #ebe7e7;
  font-size: 14px;
  line-height: 1;
  width: 35%;
  cursor: pointer;
}
.btn-filter:hover {
  color: #fff !important;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
.dropdown-menu {
  box-shadow: 0px 0px 7px gray !important;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/myUsers/MyUsers.vue